import fn from '@/library/fn'
import {getUserData} from '@/factory/user'
import store from '@/store'
import {stillLogged} from '@/factory/common'
import {detailEvent} from '@/factory/event'
import {detailForm, getEventPages} from '@/factory/page'
import {getTeamById, getTrx} from '@/factory/team'

const getEvent = (to) => {
  return new Promise((resolve, reject) => {
    const eventId = to.params.id
    let process = false
    if (to.name.substring(0, 5) === 'event' && eventId !== undefined) {
      if (store.state.eventData === null) process =  true
      else if (store.state.eventData.id !== eventId) process = true
    }

    if (!process) {
      return resolve(false)
    }

    detailEvent(eventId)
      .then(res => {
        return Promise.all([
            res,
            res.formId === '' ? null : detailForm(res.formId),
            res.checkinFormId === '' ? null : detailForm(res.checkinFormId),
            getEventPages(eventId)
          ]
        )
      })
      .then(res => {
        const [event, form, formCheckin, page] = res
        event.form = form
        event.formCheckin = formCheckin
        event.page = page
        store.commit('SET_EVENT_DATA', event)
        resolve(true)
      })
      .catch(err => reject(err))
  })
}

export const requireAuth = (to, from, next) => {
  if (!fn.loggedIn()) {
    return next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
  if (store.state.userData === null) store.commit('SET_APP_LOADING', true)
  Promise.all([
    store.state.userData === null ? getUserData() : null,
    store.state.userData === null ? getTeamById() : null,
    store.state.userData === null ? getTrx() : null,
    getEvent(to),
    from.name !== null ? stillLogged() : null,
  ])
    .then(res => {
      const [user, team, trx] = res
      if (user !== null) {
        store.commit('SET_AUTH_DATA', user)
        store.commit('SET_TEAM_DATA', team)
        store.commit('SET_MOB_MENU', false)
        store.commit('SET_SESSION_EXP', false)
        if (trx.data[0]) {
          store.commit('SET_TRX_DATA', trx.data[0])
        }
      }
      store.commit('SET_APP_LOADING', false)
      next()
    })
    .catch(err => {
      if  (err.status === 401) {
        fn.logout()
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      }
    })
    .finally(() => {
    })
}

export const requireUnauth = (to, from, next) => {
  store.commit('SET_APP_LOADING', false)
  store.commit('SET_AUTH_DATA', null)
  store.commit('SET_TEAM_DATA', null)
  store.commit('SET_TRX_DATA', null)
  if (fn.loggedIn()) {
    return next('/dash')
  }
  next()
}

export const logout = (to, from, next) => {
  store.commit('SET_APP_LOADING', false)
  fn.logout()
  next('/login')
}

export const requireCheckInAuth = (to, from, next) => {
  store.commit('SET_APP_LOADING', false)
  if (fn.loggedIn()) {
    next(`/checkin-in/${to.params.billingId}`)
  } else {
    next()
  }
}